import React, { useContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar/navbar";
import NavbarMobile from "./components/navbar/navbarMobile";
import {
  Accueil,
  Capsules,
  Contact,
  HistoriqueStrategies,
  HistoriqueAdmin,
  Questionnaire
} from './pages';
import CheminQuestions from "./components/questionnaire/cheminQuestions";
import { KeycloackContext } from "./services/keycloakProvider";
import { SessionContext } from "./services/SessionProvider";
import ShowStrategie from "./components/historique/showStrategie";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function App() {
  const { userKeycloak, authenticated } = useContext(KeycloackContext);
  const { setDevice } = useContext(SessionContext);

  const [windowSize, setWindowSize] = useState(getWindowDimensions());

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const smallMobile = windowSize.width < 1300;
    setDevice(smallMobile);
  }, [windowSize.width, setDevice]);

  const smallMobile = windowSize.width < 1300;

  if (userKeycloak) {
    if (authenticated) {
      return (
        <Router>
          {!smallMobile && <Navbar />}
          {smallMobile && <NavbarMobile />}
          <Routes>
            <Route exact path="/" element={<Accueil />} />
            <Route path="/strategies" element={<HistoriqueStrategies />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/capsules" element={<Capsules />} />
            <Route path="/historique" element={<HistoriqueAdmin />} />
            <Route path="/questionnaire" element={<Questionnaire />} />
            <Route path="/questionnaire/:questionId" element={<CheminQuestions />} />
            <Route path="/strategie/:questionId" element={<ShowStrategie />} />
          </Routes>
        </Router>
      );
    }

    return <div className='my-12'>Unable to authenticate!</div>;
  }

  return (
    <>
      <div className='my-12'>Initializing Keycloak...</div>
    </>
  );
}

export default App;
